import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { classificationItemPropType } from '../../utils/propTypes';
import { handleHotelProductSelect, handleConceptHotelSelect } from '../../redux/actions/siteSettingsActions'
import ViewHeader from '../../components/viewHeader/viewHeader';
import CarouselPicker from '../../components/carouselPicker/carouselPicker';
import '../../styles/classificationsPicker.scss';

const HotelProductsView = ({
  hotelProducts,
  selectedHotelProducts,
  onHandleHotelProductSelect,
  conceptHotels,
  selectedConceptHotels,
  onHandleConceptHotelsSelect,
  labels,
}) => {
  if (!hotelProducts) {
    return <p>Loading...</p>
  }
  
  return (
    <section className="vf-view vf-classifications-view vf-hp-view">
      <ViewHeader
        header={labels.hotelProductsHeader}
        subHeader={labels.hotelProductsSubHeader} />
      <div className="vf-hp-view__carousel-wrapper">
        <p>{labels.accommodationFilterPopularChoices}</p>
        <CarouselPicker
          fullSize
          limit={3}
          options={hotelProducts}
          selected={selectedHotelProducts}
          onSelect={onHandleHotelProductSelect} />
      </div>
      <div className="vf-hp-view__carousel-wrapper">
        <p>{labels.accommodationFilterConceptHotels}</p>
        <CarouselPicker
          limit={3}
          fullSize={false}
          hideNavArrows
          options={conceptHotels}
          selected={selectedConceptHotels}
          onSelect={onHandleConceptHotelsSelect} />
      </div>
    </section>
  );
};

HotelProductsView.propTypes = {
  hotelProducts: PropTypes.objectOf(classificationItemPropType).isRequired,
  selectedHotelProducts: PropTypes.arrayOf(PropTypes.string).isRequired,
  onHandleHotelProductSelect: PropTypes.func.isRequired,
  conceptHotels: PropTypes.objectOf(classificationItemPropType).isRequired,
  selectedConceptHotels: PropTypes.arrayOf(PropTypes.string).isRequired,
  onHandleConceptHotelsSelect: PropTypes.func.isRequired,
  labels: PropTypes.shape({
    hotelProductsHeader: PropTypes.string.isRequired,
    hotelProductsSubHeader: PropTypes.string.isRequired,
    accommodationFilterPopularChoices: PropTypes.string.isRequired,
    accommodationFilterConceptHotels: PropTypes.string.isRequired,
  }).isRequired,
};

const mapStateToProps = ({ siteSettings, attributeCollection }) => {
  const labels = {
    hotelProductsHeader: attributeCollection.hotelProductsHeader,
    hotelProductsSubHeader: attributeCollection.hotelProductsSubHeader,
    accommodationFilterPopularChoices: attributeCollection.accommodationFilterPopularChoices,
    accommodationFilterConceptHotels: attributeCollection.accommodationFilterConceptHotels,
  }
  return {
    hotelProducts: siteSettings.hotelProducts,
    selectedHotelProducts: siteSettings.filters.selectedHotelProducts,
    conceptHotels: siteSettings.conceptHotels,
    selectedConceptHotels: siteSettings.filters.selectedConceptHotels,
    onHandleConceptHotelsSelect: PropTypes.func.isRequired,
    labels,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onHandleHotelProductSelect: (hotelProduct) => {
      dispatch(handleHotelProductSelect(hotelProduct));
    },
    onHandleConceptHotelsSelect: (conceptHotel) => {
      dispatch(handleConceptHotelSelect(conceptHotel));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HotelProductsView);
